import { graphql } from "gql.tada";

// FRAGMENTS
// Removed: gql.tada doesn't support fragment spreads across separate graphql() calls
// Fragments are now inlined directly in queries

// QUERIES

const ProjectQry = graphql(`
  query project($input: GetProjectInput!) {
    project(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        fullName
      }
      mandator
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
        active
        accessoryId
        accessoryGroupId
        selectedAccessories {
          seriesId
          pimId
          seriesName
          currentPresentation
          accessoryId
          accessoryGroupId
          infoText
          ordercode {
            parts {
              options {
                signatures {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                currentSignature {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                state
                range {
                  min
                  max
                }
                type
                separator
                key
                title
                presentation
              }
              state
              key
              title
              presentation
            }
            key
            title
            presentation
          }
          optionStates {
            partKey
            optionKey
            signatureKey
            parentRef {
              partKey
              optionKey
            }
            isSizePart
            signatureValue
            signaturePresentation
            separator
          }
          lastChange {
            partKey
            optionKey
            signatureKey
            parentRef {
              partKey
              optionKey
            }
            isSizePart
            signatureValue
            separator
          }
        }
      }
    }
  }
`);

const ProjectStatusesQry = graphql(`
  query currentUser {
    currentUser {
      id
    }
    projectStatuses {
      status
      color
    }
  }
`);

const ProjectListQry = graphql(`
  query currentUser(
    $limit: Int!
    $page: Int!
    $order: String
    $filters: ProjectListFilterInput
  ) {
    currentUser {
      id
      projectList(
        limit: $limit
        page: $page
        order: $order
        filters: $filters
      ) {
        limit
        page
        pages
        projectsCount
        statistics {
          statuses
          shared
          notShared
        }
        overallStatistics {
          statuses
          shared
          notShared
        }
        filters {
          searchQuery
          statuses
          sharedStatusSwitcher
        }
        items {
          title
          id
          status {
            status
            color
          }
          constructionTitle
          createdAt
          updatedAt
          description
          projectNumber
          sharedWith {
            id
          }
          lastEditBy {
            fullName
          }
        }
      }
    }
  }
`);

const ProjectListAndStatusesQry = graphql(`
  query projectStatuses(
    $limit: Int!
    $page: Int!
    $order: String
    $filters: ProjectListFilterInput
  ) {
    projectStatuses {
      status
      color
    }
    currentUser {
      id
      projectList(
        limit: $limit
        page: $page
        order: $order
        filters: $filters
      ) {
        limit
        page
        pages
        projectsCount
        statistics {
          statuses
          shared
          notShared
        }
        overallStatistics {
          statuses
          shared
          notShared
        }
        filters {
          searchQuery
          statuses
          sharedStatusSwitcher
        }
        items {
          title
          id
          status {
            status
            color
          }
          constructionTitle
          createdAt
          updatedAt
          description
          projectNumber
          sharedWith {
            id
          }
          lastEditBy {
            fullName
          }
        }
      }
    }
  }
`);

// _________Removed pages from field,projectsCount, remebr to add when it is ready _______

const ProjectListTitlesAndIds = graphql(`
  query currentUser(
    $limit: Int!
    $page: Int!
    $filters: ProjectListFilterInput
  ) {
    currentUser {
      id
      projectList(limit: $limit, page: $page, filters: $filters) {
        limit
        page

        items {
          title
          id
          country
          mandator
        }
      }
    }
  }
`);

const ProjectCommissioningCalcQry = graphql(`
  query commissioningCalculation($input: CommissioningCalculationInput!) {
    commissioningCalculation(input: $input) {
      data {
        id
        progress
        price
        currency
      }
    }
  }
`);

const CountryListQry = graphql(`
  query countryList($input: CountryListInput!) {
    countryList(input: $input) {
      items {
        isoTwoLetterCode
        englishName
        displayName
      }
    }
  }
`);

const GetReportQry = graphql(`
  query reportArchive($input: GetReportArchiveInput!) {
    reportArchive(input: $input) {
      status
      url
    }
  }
`);

export {
  ProjectQry,
  ProjectStatusesQry,
  ProjectListQry,
  ProjectListAndStatusesQry,
  ProjectListTitlesAndIds,
  ProjectCommissioningCalcQry,
  CountryListQry,
  GetReportQry,
};
